import { useQuery } from 'react-query';

import { GqlRequestOptions } from '@common/api-request';
import { checkValidCatalogProductId, queryOptions } from '@domains/pdp-common';

import { getUserMembership } from '../graphql/pdp-user-membership.2';

export interface GetUserMembershipParam {
  catalog_product_id: string;
  final_price: number | null;
}
export function getUserMembershipQueryOption(param: GetUserMembershipParam, options?: GqlRequestOptions) {
  return {
    queryKey: ['getUserMembership', param.final_price],
    queryFn: async function () {
      const { data } = await getUserMembership(
        {
          input: {
            catalog_product_id: param.catalog_product_id,
            final_price: param.final_price,
          },
        },
        { ...options, show_alert: false },
      );
      return data.pdp_user_base_info;
    },
    ...queryOptions,
    enabled: checkValidCatalogProductId(param.catalog_product_id) && Number.isInteger(param.final_price),
  };
}

export function useUserMembershipQuery(param: GetUserMembershipParam, options?: GqlRequestOptions) {
  const DEFAULT_DATA = {
    pdp_user_membership: null,
  };
  const response = useQuery(getUserMembershipQueryOption(param, options));
  return {
    ...response,
    pdp_user_base_info: response.error || !response.data ? DEFAULT_DATA : response.data,
  };
}
